import { EmployeeGroupState, announcementsSelector } from './employee-group-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import { Action, updateStatusById, setStatusDirtyById } from '../reducers/utils/state-manager';

import { allEmployeesKey } from '../util/all-employees-option';

const InitialState: EmployeeGroupState = {
  employeeGroupsByOrgId: {},
  employeeGroupsByOrgIdStatus: {},
  announcementsByEmployeeGroupId: {},
  announcementsByEmployeeGroupIdStatus: {},
};

export const employeeGroupReducer = (state = InitialState, action: Action) => {
  switch (action.type) {
    case STARTING('REASSIGN_EMPLOYEE_GROUPS'):
    case STARTING('LOAD_EMPLOYEE_GROUPS'): {
      const { orgId } = action.payload.args;
      return updateStatusById(state, 'employeeGroupsByOrgId', true, orgId);
    }
    case SUCCESS('LOAD_EMPLOYEE_GROUPS'): {
      const { args, data } = action.payload;
      return updateStatusById(state, 'employeeGroupsByOrgId', false, args.orgId, data);
    }
    case SUCCESS('REASSIGN_EMPLOYEE_GROUPS'):
    case SUCCESS('DELETE_EMPLOYEE_GROUP'):
    case SUCCESS('UPDATE_EMPLOYEE_GROUP'): {
      const { orgId, employeeGroupId } = action.payload.args;
      const newStatus = setStatusDirtyById(state, 'employeeGroupsByOrgId', orgId);
      return setStatusDirtyById(newStatus, 'announcementsByEmployeeGroupId', employeeGroupId);
    }
    case SUCCESS('ADD_EMPLOYEE_GROUP'): {
      const { orgId } = action.payload.args;
      return setStatusDirtyById(state, 'employeeGroupsByOrgId', orgId);
    }
    case STARTING('LOAD_EMPLOYEE_GROUP_ANNOUNCEMENTS'): {
      const { employeeGroupId } = action.payload.args;
      return updateStatusById(state, 'announcementsByEmployeeGroupId', true, employeeGroupId);
    }
    case SUCCESS('LOAD_EMPLOYEE_GROUP_ANNOUNCEMENTS'): {
      const { args, data } = action.payload;
      return updateStatusById(
        state,
        'announcementsByEmployeeGroupId',
        false,
        args.employeeGroupId,
        data,
      );
    }
    case SUCCESS('CREATE_ANNOUNCEMENT'): {
      const { employeeGroupId } = action.payload.args;
      return setStatusDirtyById(state, 'announcementsByEmployeeGroupId', employeeGroupId);
    }
    case SUCCESS('UPDATE_ANNOUNCEMENT'): {
      const { announcementId } = action.payload.args;
      const announcements = announcementsSelector({ employeeGroups: state });
      const announcement = announcements.find((a) => a.announcementId === announcementId);
      if (!announcement) {
        return state;
      }
      let employeeGroupId = announcement.EmployeeGroup?.employeeGroupId as number | string | null;
      if (!employeeGroupId) {
        employeeGroupId = allEmployeesKey(announcement.orgId);
      }
      return setStatusDirtyById(state, 'announcementsByEmployeeGroupId', String(employeeGroupId));
    }
    case FAILURE('UPDATE_ANNOUNCEMENT'): {
      const { announcementId } = action.payload.args;
      const announcements = announcementsSelector({ employeeGroups: state });
      const announcement = announcements.find((a) => a.announcementId === announcementId);
      if (!announcement) {
        return state;
      }
      let employeeGroupId = announcement.EmployeeGroup?.employeeGroupId as number | string | null;
      if (!employeeGroupId) {
        employeeGroupId = allEmployeesKey(announcement.orgId);
      }
      return updateStatusById(
        state,
        'announcementsByEmployeeGroupId',
        false,
        String(employeeGroupId),
      );
    }
    default:
      return state;
  }
};
